<template>
  <v-container fluid class="footer pb-7">
    <div>
      Thanks for visiting &#9787;
    </div>
    <contact-bar />
  </v-container>
</template>

<script>
import ContactBar from '../utilities/ContactBar.vue';
export default {
  name: 'SiteFooter',
  components: {
    ContactBar,
  },
};
</script>

<style>
.footer {
  color: #f5f7fa;
  background-color: #011525;
  text-align: center;
}
</style>
